import "./AdvancedPackage.module.css";
import Header from "@/reusable_sections/Header";
import AdvancedPackageOverview from "./sections/AdvancedPackageOverview";
import AdvancedPackageFeatures from "./sections/AdvancedPackageFeatures";
import AdvancedPackagePricing from "./sections/AdvancedPackagePricing";
import Footer from "@/reusable_sections/Footer";
export default function AdvancedPackagePage() {
  return <div>
      <Header />
      <AdvancedPackageOverview />
      <AdvancedPackageFeatures />
      <AdvancedPackagePricing />
      <Footer />
    </div>;
}